import {Address} from "./address";
import {Contact} from "./contact";
import {LookAndFeelBank} from "./lookAndFeelBank";
import {BankDocument} from "./bankDocument";

export class Bank {
    id:string;
    tempId:string;
    name:string;
    phone:string;
    address:Address = new Address(null);
    contacts:Contact[] = [];

    lookAndFeelData:LookAndFeelBank = new LookAndFeelBank(null);

    logo:BankDocument;

    constructor(other ?:Bank) {
        if (other) {
            this.id = other.id;
            this.tempId = other.tempId;
            this.name = other.name;
            this.phone = other.phone;
            this.address = new Address(other.address);
            this.contacts = other.contacts.map((contact) => new Contact(contact));

            this.lookAndFeelData = new LookAndFeelBank(other.lookAndFeelData);

            this.logo = new BankDocument(other.logo);
        }
    }
}


/** WEBPACK FOOTER **
 ** ./src/app/domain/bank.ts
 **/